// 比一比商品页面
export default {
  routes: [
    {
      path: '/goods-compare',
      name: 'goods-compare',
      meta: {
        pageId: 'G2288',
        desc: '选择对比商品',
        level: 2
      },
      component: () =>
        import(/* webpackChunkName: "goodsCompare" */ '../views/goodsCompare/index.vue')
    }
  ]
}
